{
  "name": "manualradar",
  "version": "0.3.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "build-dev": "ng build",
    "copy-dev": "node transfer.js dev"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.16",
    "@angular/common": "^20.3.16",
    "@angular/compiler": "^20.3.16",
    "@angular/core": "^20.3.16",
    "@angular/forms": "^20.3.16",
    "@angular/platform-browser": "^20.3.16",
    "@angular/platform-browser-dynamic": "^20.3.16",
    "@angular/router": "^20.3.16",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "bootstrap": "^5.3.8",
    "moment": "^2.30.1",
    "ng2-file-upload": "^9.0.0",
    "ngx-bootstrap": "^20.0.2",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.2",
    "sweetalert2": "^11.17.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.17",
    "@angular/cli": "^20.3.17",
    "@angular/compiler-cli": "^20.3.16",
    "@types/node": "^24.3.0",
    "node-ssh": "^13.2.1",
    "typescript": "~5.9.2",
    "zip-a-folder": "^3.1.9"
  }
}
